import { render, staticRenderFns } from "./download.vue?vue&type=template&id=55ceb64a&"
import script from "./download.vue?vue&type=script&lang=js&"
export * from "./download.vue?vue&type=script&lang=js&"
import style0 from "./download.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55ceb64a')) {
      api.createRecord('55ceb64a', component.options)
    } else {
      api.reload('55ceb64a', component.options)
    }
    module.hot.accept("./download.vue?vue&type=template&id=55ceb64a&", function () {
      api.rerender('55ceb64a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_home/download.vue"
export default component.exports